<template>
  <div>
    <overview-section-card v-if="canHaveMultipleProjects && user_sub_id !== 3">
      <v-card-title class="pb-2">
        <span class="overview-section-title">{{ $t('overview.limits') }}</span>
      </v-card-title>
      <v-card-text>
        {{ $t('overview.multiple_projects_message') }}<br><br>
        <v-btn color="primary" @click="upgradePlan">{{$t('overview.visit_my_profile')}}</v-btn>
      </v-card-text>
    </overview-section-card>
    <user-limits
      v-if="canHaveOneProject"
      :show-upgrade-button="true"
      header-type="projectOverview"
      :use-overview-section-card="true"
    />
  </div>
</template>

<script>

import UserLimits from '@/components/myprofile/UserLimits';
import CurrentUserMixin from '@/mixins/CurrentUserMixin.vue';
import OverviewSectionCard from '@/components/overview/OverviewSectionCard.vue';

export default {
  name: 'OneProjectLimits.vue',
  components: { UserLimits, OverviewSectionCard },
  mixins: [CurrentUserMixin],
  data() {
    return {
    };
  },
  methods: {
    upgradePlan() {
      this.$router.push({ name: 'MyProfile' });
    },
  },
  computed: {
    canHaveMultipleProjects() {
      return [2, 3].includes(parseInt(this.user_sub_id));
    },
    canHaveOneProject() {
      return [0, 1].includes(parseInt(this.user_sub_id));
    }
  },
}
</script>

<style scoped>

</style>
